<my-content placeholder="navigation">
    <!-- <app-confirm-dialog></app-confirm-dialog> -->
    <!-- <router-outlet></router-outlet> -->
    <div class="container-fluid">
        <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
            {{TypeHeader}}
            <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
            </button>
        </div>
        <form [formGroup]="addFormNotice" (ngSubmit)="onHeaderSubmit(addFormNotice.value)">
        <div class="card rounded-4 border-0">
            <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="CaseDecision">{{Type}}<span style="color:red;">*</span></label>
                                <br>
                                <label class="radio-inline"><input type="radio" formControlName="Notice"
                                        value="1">{{Sent}}</label>
                                <label class="radio-inline"><input type="radio" formControlName="Notice"
                                        value="0">{{Received}}</label>
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="RefNo"> {{RefNo}} <span style="color:red;">*</span></label>
                                <input type="text" formControlName="RefNo" class="form-control" id="RefNo" />
                                @if (f.RefNo.touched && f.RefNo.invalid) {
                                    <div class="text-danger">
                                        @if (f.RefNo.errors?.['required']) {
                                            <small> {{RefNo}} is required.</small>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="Manager">{{captionManager}}<span style="color:red;">*</span> </label>
                                <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Manager"
                                    [clearable]="false" placeholder="Select {{captionManager}}">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name}}
                                    </ng-template>
                                </ng-select>
                                @if (f.Manager.touched && f.Manager.invalid) {
                                    <div class="text-danger">
                                        @if (f.Manager.errors?.['required']) {
                                            <small>{{captionManager}} is required.</small>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="Leader">{{captionLeader}} <span style="color:red;">*</span> </label>
                                <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Leader"
                                    [clearable]="false" placeholder="Select {{captionLeader}}">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name}}
                                    </ng-template>
                                </ng-select>
                                @if (f.Leader.touched && f.Leader.invalid) {
                                    <div class="text-danger">
                                        @if (f.Leader.errors?.['required']) {
                                            <small>{{captionLeader}} is required.</small>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label><a routerLink="/addorgcontact/0/0" target="_blank">{{ captionFilingParty }}</a> <span style="color:red;">*</span> </label>
                                <ng-select [items]="filteredFillingParty" [multiple]="true" [closeOnSelect]="false" bindLabel="Name"
                                bindValue="ID" formControlName="fillingPartyName" placeholder="Select {{captionFilingParty}}">

                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.Name }}
                                </ng-template>

                                </ng-select>
                                @if (f.fillingPartyName.touched && f.fillingPartyName.invalid) {
                                    <div class="text-danger">
                                        @if (f.fillingPartyName.errors?.['required']) {
                                            <small>{{captionFilingParty}} is required.</small>
                                        }
                                    </div>
                                }
                            </div>
                            </div>
                            <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label><a routerLink="/addorgcontact/0/0" target="_blank">{{captionOppositeParty}}</a> <span style="color:red;">*</span> </label>
                                <ng-select [items]="filteredOppositeParty" [multiple]="true" [closeOnSelect]="false" bindLabel="Name"
                                bindValue="ID" formControlName="OppositePartyName" placeholder="Select {{captionOppositeParty}}">

                                <ng-template ng-option-tmp let-item="item">
                                    {{ item.Name }}
                                </ng-template>

                                </ng-select>
                                @if (f.OppositePartyName.touched && f.OppositePartyName.invalid) {
                                    <div class="text-danger">
                                        @if (f.OppositePartyName.errors?.['required']) {
                                            <small>{{captionOppositeParty}} is required.</small>
                                        }
                                    </div>
                                }
                            </div>
                            </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="DateofNotice">Date of {{Type}}<span style="color:red;">*</span></label>
                                <mat-form-field class="fullwidth" appearance="outline" >
                                    <input matInput [readonly]="!editable" [min]="minDate"
                                        formControlName="DateofNotice" [max]="maxDate" [matDatepicker]="picker"
                                        placeholder="Choose a date" class="">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                @if (f.DateofNotice.touched && f.DateofNotice.invalid) {
                                    <mat-error>
                                        @if (f.DateofNotice.errors?.['required']) {
                                            Date of {{Type}} is required.
                                        }
                                    </mat-error>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="TargetDate">{{captionTargetDate}} <span style="color:red;">*</span> </label>
                                <mat-form-field class="fullwidth" appearance="outline">
                                    <input matInput [readonly]="!editable" [min]="minDate" formControlName="TargetDate"
                                        [max]="maxDate" [matDatepicker]="picker2" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                                @if (f.TargetDate.touched && f.TargetDate.invalid) {
                                    <mat-error>
                                        @if (f.TargetDate.errors?.['required']) {
                                            {{captionTargetDate}} is required.
                                        }
                                    </mat-error>
                                }
                            </div>
                        </div>
                        <div class="col-12 col-md-4">
                            <div class="form-group">
                                <label for="DueDate">{{DueDate}} <span style="color:red;">*</span> </label>
                                <mat-form-field class="fullwidth" appearance="outline">
                                    <input matInput [readonly]="!editable" [min]="minDate" formControlName="DueDate"
                                        [max]="maxDate" [matDatepicker]="picker3" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                    <mat-datepicker #picker3></mat-datepicker>
                                </mat-form-field>
                                @if (f.DueDate.touched && f.DueDate.invalid) {
                                    <mat-error>
                                        @if (f.DueDate.errors?.['required']) {
                                            {{DueDate}} is required.
                                        }
                                    </mat-error>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if ( !HideContent  && (Type == 'Case' && RightsID.includes('202032001')) || (Type == 'Case' && RightsID.includes('202032021')) || (Type == 'Notice' && RightsID.includes('202030001')) || (Type == 'Notice' && RightsID.includes('202030021')) ) {
                <div class="d-flex align-items-center justify-content-center mt-3">
                    <button class="btn btn-primary submit-btn small" [type]="DisplaySaveNoticeButton" [disabled]="clicked">
                        {{ HeaderButtonCaption }}
                    </button>
                </div>
            } 
        </form>
    </div>
    <!-- <div class="col-sm-12 mt-3"> -->
        <!-- <div class="titlebar d-flex align-items-center justify-content-between">
            <div></div>
            <div class="titlebar-text">
                <i class="fa fa-briefcase text-primary"></i>
                <span class="ml-2 page-title">{{TypeHeader}}</span>
            </div>

            <button class="btn btn-primary back-btn" title="Go Back" (click)="goBack()">
                <i class="fa fa-arrow-left"></i> Back
            </button>
        </div> -->

<!-- 
        <form #AddNotice="ngForm" [formGroup]="addFormNotice" (ngSubmit)="onHeaderSubmit(AddNotice.value);">

            <div class="">
                <table width="100%" class="LMtable_lite entry">
                    <tr>
                        <td width="15%">{{Type}}<span style="color:red;">*</span></td>
                        <td width="35%">
                            <div class="col-sm-11"><label class="radio-inline"><input type="radio"
                                        formControlName="Notice" value="1">{{Sent}}</label>
                                <label class="radio-inline"><input type="radio" formControlName="Notice"
                                        value="0">{{Received}}</label>
                            </div>
                        </td>
                        <td width="15%">Ref No. <span style="color:red;">*</span></td>
                        <td width="35%">
                            <div class="col-sm-11">

                                <input type="text" formControlName="RefNo" class="form-control">

                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td><a routerLink="{{RouteUserMaster}}" target="_blank">Manager<span
                                    style="color:red;">*</span></a></td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Manager"
                                    [clearable]="false" placeholder="[Not Selected]">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </td>


                        <td><a routerLink="{{RouteUserMaster}}" target="_blank">Leader </a></td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select [items]="Manager" bindLabel="name" bindValue="id1" formControlName="Leader"
                                    [clearable]="false" placeholder="[Not Selected]">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><a routerLink="/addorgcontact/0/0" target="_blank">Filling Party </a></td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select [items]="FillingOppoParty" [clearable]="false" [multiple]="true"
                                    formControlName="fillingPartyName" bindLabel="Name" [selectableGroup]="true"
                                    [closeOnSelect]="true" bindValue="ID" [(ngModel)]="selectedFillingParty">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.Name}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </td>
                        <td><a routerLink="/addorgcontact/0/0" target="_blank">Opposite Party </a></td>
                        <td>
                            <div class="col-sm-11">
                                <ng-select [items]="FillingOppoParty" [clearable]="false" [multiple]="true"
                                    formControlName="OppositePartyName" bindLabel="Name" [selectableGroup]="true"
                                    [closeOnSelect]="true" bindValue="ID" [(ngModel)]="selectedOppositeParty">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.Name}}
                                    </ng-template>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Date of {{Type}}<span style="color:red;">*</span></td>
                        <td>
                            <div class="col-sm-11">
                                <mat-form-field class="fullwidth">
                                    <input matInput [readonly]="!editable" [min]="minDate"
                                        formControlName="DateofNotice" [max]="maxDate" [matDatepicker]="picker"
                                        placeholder="Choose a date" class="">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>

                            </div>
                        </td>


                        <td>Target Date</td>
                        <td>
                            <div class="col-sm-11">
                                <mat-form-field class="fullwidth">
                                    <input matInput [readonly]="!editable" [min]="minDate" formControlName="TargetDate"
                                        [max]="maxDate" [matDatepicker]="picker2" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                    <mat-datepicker #picker2></mat-datepicker>
                                </mat-form-field>
                            </div>

                        </td>
                    </tr>
                    <tr>
                        <td>Due Date</td>
                        <td>
                            <div class="col-sm-11">
                                <mat-form-field class="fullwidth">
                                    <input matInput [readonly]="!editable" [min]="minDate" formControlName="DueDate"
                                        [max]="maxDate" [matDatepicker]="picker3" placeholder="Choose a date">
                                    <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                    <mat-datepicker #picker3></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </td>
                        <td></td>
                    </tr>

                </table>
            </div>
            <div class="col-sm-12">&nbsp;</div>
            <div class="col-sm-12">
                <div class="col-sm-5"></div>
                <div [hidden]="HideContent"
                    *ngIf="(this.Type == 'Case' && this.RightsID.includes('202032001')) || (this.Type == 'Case' && this.RightsID.includes('202032021')) || (this.Type == 'Notice' && this.RightsID.includes('202030001')) || (this.Type == 'Notice' && this.RightsID.includes('202030021')) ; then HeaderButtonLink else HeaderButton">
                </div>
                <ng-template #HeaderButtonLink>
                    <input class="btn btn-primary col-sm-2" [type]="DisplaySaveNoticeButton"
                        value={{HeaderButtonCaption}} [disabled]="clicked">
                </ng-template>
                <ng-template #HeaderButton>
                    <div class="col-sm-2">&nbsp;</div>
                </ng-template>


                <div class="col-sm-5"></div>
            </div>
            <div class="col-sm-12">&nbsp;</div>
        </form> -->
    <!-- </div> -->

</my-content>
<my-content placeholder="main">

</my-content>